import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TermsConditions.css';

const TermsConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-page">
      <div className="terms-container">
        {/* Header */}
        <header className="terms-header">
          <div className="header-content">
            <div className="logo-container">
              <img src="/favicon.ico" alt="TabTrips" className="logo" />
              <div className="brand-text">
                <h1 className="brand-title">TabTrips</h1>
                <p className="brand-subtitle">Terms & Conditions</p>
              </div>
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="terms-content">
          <div className="content-wrapper">
            <h1 className="page-title">Terms & Conditions</h1>
            <p className="last-updated">Last updated: January 2024</p>

            <section className="terms-section">
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing and using the TabTrips Extranet Portal, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
            </section>

            <section className="terms-section">
              <h2>2. Use License</h2>
              <p>Permission is granted to temporarily access the materials on TabTrips's extranet portal for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
              <ul>
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to reverse engineer any software contained on the portal</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>3. Property Management Services</h2>
              <p>As a property partner using our extranet portal, you agree to:</p>
              <ul>
                <li>Provide accurate and up-to-date property information</li>
                <li>Maintain competitive pricing and availability</li>
                <li>Respond promptly to booking requests and inquiries</li>
                <li>Ensure your property meets quality standards</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>4. Booking and Payment Terms</h2>
              <p>All bookings processed through our platform are subject to the following terms:</p>
              <ul>
                <li>Commissions are calculated based on confirmed bookings</li>
                <li>Payment processing follows our standard 30-day cycle</li>
                <li>Cancellation policies must be clearly communicated</li>
                <li>Refunds are processed according to our refund policy</li>
                <li>Disputes are resolved through our customer service team</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>5. User Account Responsibilities</h2>
              <p>You are responsible for:</p>
              <ul>
                <li>Maintaining the confidentiality of your account credentials</li>
                <li>All activities that occur under your account</li>
                <li>Notifying us immediately of any unauthorized use</li>
                <li>Ensuring your account information is accurate and current</li>
                <li>Logging out of your account when accessing from shared devices</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>6. Prohibited Activities</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Use the service for any unlawful purpose</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with or disrupt the service</li>
                <li>Transmit viruses or malicious code</li>
                <li>Engage in any activity that could harm our platform or users</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>7. Intellectual Property</h2>
              <p>The content, features, and functionality of the TabTrips Extranet Portal are owned by TabTrips and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.</p>
            </section>

            <section className="terms-section">
              <h2>8. Privacy and Data Protection</h2>
              <p>Your privacy is important to us. Our collection and use of personal information is governed by our Privacy Policy, which is incorporated into these Terms by reference.</p>
            </section>

            <section className="terms-section">
              <h2>9. Limitation of Liability</h2>
              <p>TabTrips shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the service.</p>
            </section>

            <section className="terms-section">
              <h2>10. Indemnification</h2>
              <p>You agree to defend, indemnify, and hold harmless TabTrips and its affiliates from and against any claims, damages, obligations, losses, liabilities, costs, or debt arising from your use of the service.</p>
            </section>

            <section className="terms-section">
              <h2>11. Service Availability</h2>
              <p>We strive to maintain high availability of our extranet portal, but we do not guarantee uninterrupted access. We may perform maintenance or updates that temporarily affect service availability.</p>
            </section>

            <section className="terms-section">
              <h2>12. Termination</h2>
              <p>We may terminate or suspend your account and access to the service immediately, without prior notice, for any reason, including breach of these Terms. Upon termination, your right to use the service will cease immediately.</p>
            </section>

            <section className="terms-section">
              <h2>13. Governing Law</h2>
              <p>These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.</p>
            </section>

            <section className="terms-section">
              <h2>14. Changes to Terms</h2>
              <p>We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the new Terms on this page and updating the "Last updated" date.</p>
            </section>

            <section className="terms-section">
              <h2>15. Contact Information</h2>
              <p>If you have any questions about these Terms & Conditions, please contact us:</p>
              <div className="contact-info">
                <p><strong>Email:</strong> legal@tabtrips.com</p>
                <p><strong>Phone:</strong> +91 7082828181</p>
                <p><strong>Address:</strong> TabTrips Headquarters, India</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions; 